<template>
  <div data-test="processing-item-form">
    <!-- TKP-196 kriter 5: TEK işleme kaydını düzenle — amaç / hukuki sebep / meşru menfaat; kaydet yalnız bu kaydı değiştirir
         (ilgili kişinin kümesi, bu kayıt yenisiyle değiştirilerek yeniden yazılır; diğer kayıtlar aynen kalır). -->
    <h6 class="mt-2">{{ $t("processing.purpose.text") }}</h6>
    <filter-select :id="id + '-purpose'" :placeholder="$t('processing.purpose.text')" :multiple="false" @filter="onPurposeSearch" :selected="purpose" @changed="(v) => (purpose = v || null)" />
    <h6 class="mt-3">{{ $t("processing-transfering.legal-reason.text") }}</h6>
    <filter-select :id="id + '-legal-reason'" :placeholder="$t('processing-transfering.legal-reason.text')" :multiple="false" @filter="onLegalReasonSearch" :selected="legalReason" @changed="(v) => (legalReason = v || null)" />
    <h6 class="mt-3">{{ $t("processing-transfering.legitimate-interest.text") }}</h6>
    <textarea v-model="legitimateInterest" class="form-control form-control-sm" rows="3" :placeholder="$t('processing-transfering.legitimate-interest.info')" data-test="processing-item-li"></textarea>
    <div v-if="!purpose && !legalReason" class="small text-danger mt-1" data-test="processing-item-empty">{{ $t("inventory.hierarchy.processing-item-empty") }}</div>
    <sweet-button @click="save()" :loading="isUpdating" :disabled="isUpdating || (!purpose && !legalReason)" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-3" data-test="processing-item-save">
      {{ $t("common.save") }}
    </sweet-button>
  </div>
</template>

<script>
import { purposeKindOfContext, purposeKindQuery } from "@modules/processing-transferring/purpose-kind";

export default {
  name: "processing-item-form",
  /** `item`: düzenlenen kayıt ({ _id, purpose, legalReason, legitimateInterest }); `items`: satırın tüm kayıtları; `row`: ilgili kişi satırı */
  props: ["id", "item", "items", "row"],
  data() {
    return { purpose: null, legalReason: null, legitimateInterest: "" };
  },
  computed: {
    isUpdating() {
      return this.$store.getters["datasubjectProcessingLegal/isUpdating"];
    },
  },
  watch: {
    item: {
      immediate: true,
      handler(v) {
        const lib = (part) => (part && part.libraryItem && part.libraryItem._id ? { ...part, _id: part.libraryItem._id } : null);
        this.purpose = lib(v && v.purpose);
        this.legalReason = lib(v && v.legalReason);
        const li = v && v.legitimateInterest;
        this.legitimateInterest = li && typeof li === "object" ? li[this.currentLanguage] || li.tr || "" : li || "";
      },
    },
  },
  methods: {
    async onPurposeSearch(value, callback) {
      const response = await this.$store.dispatch("purpose/paginate", { options: { limit: 1000 }, query: { name: { value }, ...purposeKindQuery(purposeKindOfContext(false)) } });
      callback(response?.data?.docs ?? []);
    },
    async onLegalReasonSearch(value, callback) {
      const response = await this.$store.dispatch("legalReason/paginate", { options: { limit: 1000 }, query: { name: { value } } });
      callback(response?.data?.docs ?? []);
    },
    /** Düzenlenmiş kayıt: seçilen kütüphane kalemleri `libraryItem` ile; boş taraf undefined. */
    edited() {
      const p = this.purpose;
      const l = this.legalReason;
      const li = String(this.legitimateInterest || "");
      return {
        purpose: p ? { name: p.name, verbisAquivalent: p.verbisAquivalent, isVerbisPurpose: p.isVerbisPurpose, libraryItem: { _id: p.libraryItem ? p.libraryItem._id : p._id, name: p.name } } : undefined,
        legalReason: l ? { name: l.name, regulation: l.regulation ?? this.regulationSelectorByProduct(l), libraryItem: { _id: l.libraryItem ? l.libraryItem._id : l._id, name: l.name } } : undefined,
        legitimateInterest: { tr: li, en: li, fr: li, de: li },
      };
    },
    async save() {
      if (!(await this.confirm(this.$t("alert.approve")))) return;
      const rowId = this.row && this.row._id;
      const next = (this.items || []).map((x) => (String(x._id) === String(this.item && this.item._id) ? this.edited() : { purpose: x.purpose, legalReason: x.legalReason, legitimateInterest: x.legitimateInterest }));
      try {
        await this.$store.dispatch("datasubjectProcessingLegal/update", { datasubject: { _id: rowId }, items: next.map((i) => ({ ...i, datasubject: { _id: rowId } })) });
        this.$toast.success(this.$t("common.success"));
        this.$emit("onSaved");
        this.$root.$emit("bv::toggle::collapse", this.id);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
  },
};
</script>
